import { useCallback, useEffect, useRef, useState } from 'react'
import { checkVidaasAuthStatus, type VidaasAuthStatus } from '@/shared/api/vidaasAuthStatusApi'

const POLL_INTERVAL_MS = 60_000
const TICK_INTERVAL_MS = 1_000

export function useVidaasAuthStatus() {
  const [status, setStatus] = useState<VidaasAuthStatus>({ cached: false, expiresAt: null })
  const [isLoading, setIsLoading] = useState(true)
  const [secondsRemaining, setSecondsRemaining] = useState(0)
  const mounted = useRef(true)

  const refresh = useCallback(async () => {
    setIsLoading(true)
    const next = await checkVidaasAuthStatus()
    if (!mounted.current) return
    setStatus(next)
    setIsLoading(false)
  }, [])

  useEffect(() => {
    mounted.current = true
    // eslint-disable-next-line react-hooks/set-state-in-effect -- dispara o fetch inicial de status (setState assíncrono dentro de refresh)
    void refresh()
    const id = setInterval(() => void refresh(), POLL_INTERVAL_MS)
    return () => {
      mounted.current = false
      clearInterval(id)
    }
  }, [refresh])

  // Live countdown tick
  useEffect(() => {
    if (!status.expiresAt) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- zera o contador quando não há expiração
      setSecondsRemaining(0)
      return
    }
    const tick = () => {
      const sec = Math.max(0, Math.floor((new Date(status.expiresAt!).getTime() - Date.now()) / 1000))
      setSecondsRemaining(sec)
    }
    tick()
    const id = setInterval(tick, TICK_INTERVAL_MS)
    return () => clearInterval(id)
  }, [status.expiresAt])

  return { ...status, isLoading, secondsRemaining, refresh }
}
